/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../extensions/dataBehindTheVis/dashboard-features/DataBehindTheVisController'
], function(DataBehindTheVisController) {

	class DataBehindTheVisControllerRef extends DataBehindTheVisController {
		//TODO: Remove this class once updated perspective contribution pointing to super is in a kit
	}

	return DataBehindTheVisControllerRef;
});